import React, { useMemo, useState } from "react";
import { Facet } from "@elastic/react-search-ui";
import { useTranslation } from "react-i18next";
import queryString from "../../../../helpers/queryString";
const filterProject = (parentChild) => {
  if (!parentChild.includes("##")) {
    return false;
  }

  const [parent, child] = parentChild.split("##");
  if (parent && child) {
    return true;
  } else {
    return false;
  }
};
const OmronProductFacet = ({ onRemove, onSelect, options, ...rest }) => {
  const { t } = useTranslation();
  const [categoryOpenState, setCategoryOpenState] = useState({});

  const parentChildCategories = useMemo(() => {
    return options
      .filter(({ value }) => filterProject(value))
      .map((option) => {
        const parentChild = option.value;
        const [parentCategory, childCategory] = parentChild.split("##");
        return {
          parentCategory,
          childCategory,
          checked: option.selected,
          ...option,
        };
      })
      .reduce((groups, item) => {
        const key = item.parentCategory;
        groups[key] = groups[key] || [];
        groups[key].push(item);
        return groups;
      }, {});
  }, [options]);

  React.useEffect(() => {
    const search = queryString.parse(window.location.search);
    if (
      search &&
      (Array.isArray(search)
        ? search.length > 0
        : Object.keys(search).length > 0)
    ) {
      const { filters } = search;
      const parentMaps = options.map((option) => {
        const parentChild = option.value;
        const [parentCategory, childCategory] = parentChild.split("##");
        return parentCategory;
      });

      if (filters && filters.length) {
        filters.forEach(({ values }) => {
          const [parentCategory, childCategory] = values[0].split("##");
          if (parentMaps.includes(parentCategory)) {
            setCategoryOpenState({ [parentCategory]: true });
          }
        });
      }
    }
  }, []);

  return (
    <div className="l-localnav j-nav">
      <h2 className="c-title--main border">{t("Product Category")}</h2>
      <ul className="l-localnav__list level--0 u-form-label">
        {Reflect.ownKeys(parentChildCategories).map((parentCategory) => {
          const childCategories = parentChildCategories[parentCategory];
          return (
            <li key={parentCategory}>
              <div
                className={`parent ${categoryOpenState[parentCategory] ? "is-open" : ""}`}
                onClick={(e) => {
                  e.preventDefault();
                  setCategoryOpenState((s) => ({
                    ...s,
                    [parentCategory]: !s[parentCategory],
                  }));
                }}
              >
                <button>{parentCategory}</button>
              </div>
              <ul className="l-localnav__list level--1">
                {childCategories.map((option) => {
                  return (
                    <li key={option.value}>
                      <input
                        checked={option.checked}
                        onChange={() =>
                          option.checked
                            ? onRemove(option.value)
                            : onSelect(option.value)
                        }
                        type="checkbox"
                        id={option.value}
                      />
                      <label htmlFor={option.value}>
                        {option.childCategory}
                      </label>
                      <span className="sui-multi-checkbox-facet__option-count">
                        {option.count.toLocaleString("en")}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

const ProductFacetComponent = () => (
  <Facet
    field="field_faq_product_parent_child_category"
    label=""
    show={1000}
    view={(props) => <OmronProductFacet {...props} />}
  />
);

export default ProductFacetComponent;
